import { mixpanel } from '@/mixpanel'
import { useClearLocalSession } from '@/modules/auth/hooks/useClearLocalSession'
import { servers } from '@/modules/healthblocks/ServerProvider'
import { clearHospitalSessions } from '@/modules/shared/helpers/hospital-session'
import { useNavigate } from '@/router-wrapper'
import { usePersistedTenant } from './usePersistedTenant'

// Shared by every switch button (e.g. the profile card and the web sidebar are
// on screen together), so one switch at a time across all of them
let isSwitching = false

export function useSwitchHospital() {
  const { setPersistedTenant } = usePersistedTenant()
  const navigate = useNavigate()
  const clearLocalSession = useClearLocalSession()

  return async () => {
    if (isSwitching) return
    isSwitching = true

    try {
      await switchHospital()
    } finally {
      isSwitching = false
    }
  }

  async function switchHospital() {
    mixpanel.track('account_switch_hospital')

    // Every hospital has its own session, and a session left behind may
    // belong to another profile (e.g. a mandate), so switching hospital logs
    // out of all of them. The profile's local data goes first, while the
    // current session can still remove the push channel. Then only the
    // persisted sessions are removed: the picker lives outside the tenant
    // routes, so leaving them unmounts the AuthProvider and drops the
    // in-memory one. Signing out in place instead would make the auth guard
    // redirect to the tenant's login first.
    // Local only: the eHealth session itself stays active.
    await clearLocalSession()
    clearHospitalSessions(servers)

    setPersistedTenant(null)
    await navigate('/select-hospital', { replace: true, tenant: false })
  }
}
